import { BaseButton } from '@/components/common/base-button';
import { LocationMarkerIcon } from '@/components/icons';
import { useAccessibilityTTS } from '@/hooks';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

type Props = {
    name: string;
    selected?: boolean;
    onSelect: () => void;
    hideSelectedStyles?: boolean;
    dataModalRegion?: boolean;
    selectedPoiId?: string;
};
export const NearbyPoiItem = ({ name, selected = false, onSelect, hideSelectedStyles = false, dataModalRegion = false }: Props) => {
    const { t } = useTranslation();
    const { speak } = useAccessibilityTTS();
    const ariaLabelButton = `${t('common.tts.location')}, ${t('floor_guide.text_to_speech.nearby_poi', { poiName: name })}`;

    const generateAriaRadioLabel = (selected: boolean) => {
        return `${selected ? t('common.button.tts.status_selected') : t('common.button.tts.status_not_selected')} ${t('floor_guide.text_to_speech.nearby_poi', { poiName: name })}, ${t('common.button.tts.radio_button')}`;
    };
    return (
        <BaseButton
            data-tts-scope="nearby-poi-item"
            className={clsx(styles['poi-item'], selected && !hideSelectedStyles && styles['poi-item--selected'])}
            data-modal-region={dataModalRegion}
            onFocus={() => {
                if (hideSelectedStyles) {
                    speak(ariaLabelButton);
                } else {
                    speak(generateAriaRadioLabel(selected));
                }
            }}
            onClick={() => {
                if (hideSelectedStyles) {
                    speak(ariaLabelButton);
                } else {
                    speak(generateAriaRadioLabel(true));
                }
                onSelect();
            }}
        >
            <span className="text-text-main01">
                <LocationMarkerIcon width={24} height={24} />
            </span>
            <span className={clsx(styles['poi-item__name'], selected && !hideSelectedStyles && styles['poi-item__name--selected'])}>
                <span className={styles['poi-item__name__title']}>{t('floor_guide.title.nearby', { poiName: name })}</span>
            </span>
        </BaseButton>
    );
};
